export class LoadTestExecutionsByRunId {
	static readonly type = '[LOAD TESTS EXECUTIONS] Load test executions by run id';
	constructor(public runId: string, public projectId: string) {}
}
